<div class="div-content">
    <img class="image-apim" src="../.././../../../../assets/img/apim.png" alt="docker"/>
    <p>Redirection to APIM is in progress ...</p>

</div>